var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgClose = function SvgClose(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47717 7.69172L13.7585 12.832C14.1467 13.2098 14.1467 13.8275 13.7585 14.2052C13.3694 14.583 12.7358 14.583 12.3476 14.2052L7.06626 9.06494L1.7849 14.2052C1.39575 14.583 0.76214 14.583 0.373991 14.2052C-0.0151556 13.8275 -0.0151556 13.2098 0.373991 12.832L5.65536 7.69172L0.373891 2.55133C-0.0152554 2.17354 -0.0152554 1.55589 0.373891 1.17811C0.76204 0.799355 1.39565 0.799355 1.7848 1.17811L7.06626 6.3185L12.3477 1.17811C12.7359 0.799355 13.3695 0.799355 13.7586 1.17811C14.1468 1.55589 14.1468 2.17354 13.7586 2.55133L8.47717 7.69172Z",
    fill: "currentColor"
  })));
};
export default SvgClose;